import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

const useUserDataStore = create(
  devtools(
    persist(
      (set) => ({
        userData: {
          firstname: '',
          lastname: '',
          email: '',
          phoneNumber: '',
          image: '',
          district: '',
          town: '',
          facebookUsername: '',
          id: '', // Add id field for user _id
          role: 'user', // Add role field for admin dashboard access
        },
        setUserData: (data) =>
          set(
            (state) => ({
              userData: {
                ...state.userData,
                ...data,
              },
            }),
            false,
            'setUserData'
          ),
        clearUserData: () =>
          set(
            {
              userData: {
                firstname: '',
                lastname: '',
                email: '',
                phoneNumber: '',
                image: '',
                district: '',
                town: '',
                facebookUsername: '',
                id: '', // Add id field for user _id
                role: 'user', // Add role field for admin dashboard access
              },
            },
            false,
            'clearUserData'
          ),
      }),
      {
        name: 'user-data-storage',
        getStorage: () => localStorage,
      }
    ),
    {
      name: 'UserData Store',
      enabled: true,
    }
  )
);

export default useUserDataStore;
